
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('./runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.3.1
 * Query Engine version: 61e140623197a131c2a6189271ffee05a7aa9a59
 */
Prisma.prismaVersion = {
  client: "5.3.1",
  engine: "61e140623197a131c2a6189271ffee05a7aa9a59"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  role: 'role',
  description: 'description'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  oldId: 'oldId',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  fullName: 'fullName',
  fullNameReverse: 'fullNameReverse',
  insertedTimestamp: 'insertedTimestamp',
  updatedTimestamp: 'updatedTimestamp',
  stripeId: 'stripeId',
  rechargeCustomerId: 'rechargeCustomerId',
  rechargeHash: 'rechargeHash',
  shopifyCustomerId: 'shopifyCustomerId',
  phoneNumber: 'phoneNumber',
  klaviyoProfileId: 'klaviyoProfileId',
  cxNote: 'cxNote',
  experimentGroup: 'experimentGroup',
  persona: 'persona',
  syncedAt: 'syncedAt',
  syncedFor: 'syncedFor'
};

exports.Prisma.UserToRoleScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  roleId: 'roleId',
  insertedUserId: 'insertedUserId',
  insertedTimestamp: 'insertedTimestamp',
  updatedUserId: 'updatedUserId',
  updatedTimestamp: 'updatedTimestamp'
};

exports.Prisma.UserPasswordScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  insertedTimestamp: 'insertedTimestamp',
  updatedTimestamp: 'updatedTimestamp',
  hash: 'hash',
  salt: 'salt'
};

exports.Prisma.PasswordResetLinkScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  insertedTimestamp: 'insertedTimestamp',
  expiresAt: 'expiresAt',
  usedAt: 'usedAt',
  hash: 'hash'
};

exports.Prisma.AuthLoginCodeScalarFieldEnum = {
  id: 'id',
  passcode: 'passcode',
  insertedTimestamp: 'insertedTimestamp',
  expiresAt: 'expiresAt',
  usedAt: 'usedAt',
  redirectTo: 'redirectTo',
  userId: 'userId'
};

exports.Prisma.RefreshTokenScalarFieldEnum = {
  id: 'id',
  token: 'token',
  userId: 'userId',
  issuedAt: 'issuedAt',
  expiresAt: 'expiresAt',
  invalidatedAt: 'invalidatedAt'
};

exports.Prisma.OrderFulfilmentScalarFieldEnum = {
  id: 'id',
  boxId: 'boxId',
  rechargeSubscriptionId: 'rechargeSubscriptionId',
  rechargeCustomerId: 'rechargeCustomerId',
  rechargeOrderId: 'rechargeOrderId',
  rechargeChargeId: 'rechargeChargeId',
  katkinChargeId: 'katkinChargeId',
  katkinSubscriptionId: 'katkinSubscriptionId',
  subscriptionBoxNumber: 'subscriptionBoxNumber',
  userId: 'userId',
  catName: 'catName',
  legacyCatId: 'legacyCatId',
  katkinCatId: 'katkinCatId',
  createdAt: 'createdAt',
  createdByUserId: 'createdByUserId',
  updatedByUserId: 'updatedByUserId',
  updatedAt: 'updatedAt',
  email: 'email',
  shippingFirstName: 'shippingFirstName',
  shippingLastName: 'shippingLastName',
  shippingAddress1: 'shippingAddress1',
  shippingAddress2: 'shippingAddress2',
  shippingCompany: 'shippingCompany',
  shippingCity: 'shippingCity',
  shippingProvince: 'shippingProvince',
  shippingPostcode: 'shippingPostcode',
  shippingCountry: 'shippingCountry',
  shippingPhone: 'shippingPhone',
  dpdAccount: 'dpdAccount',
  dpdConsignment: 'dpdConsignment',
  dpdShipment: 'dpdShipment',
  shippingLabel: 'shippingLabel',
  type: 'type',
  source: 'source',
  replacementReason: 'replacementReason',
  deliveryDate: 'deliveryDate',
  status: 'status',
  submittedAt: 'submittedAt',
  cancelledAt: 'cancelledAt',
  category: 'category',
  shopifyCustomerId: 'shopifyCustomerId',
  shopifyOrderId: 'shopifyOrderId',
  fulfilledByOakland: 'fulfilledByOakland',
  duplicatedFromId: 'duplicatedFromId',
  experimentCode: 'experimentCode',
  indexWithinOrder: 'indexWithinOrder',
  populatedAt: 'populatedAt',
  yodelConsignment: 'yodelConsignment',
  yodelReference: 'yodelReference',
  yodelLabel: 'yodelLabel',
  sequenceNumber: 'sequenceNumber',
  pouchSize: 'pouchSize',
  checkedForSubscribeEventAt: 'checkedForSubscribeEventAt',
  courier: 'courier'
};

exports.Prisma.OrderFulfilmentItemScalarFieldEnum = {
  id: 'id',
  insertedAt: 'insertedAt',
  orderId: 'orderId',
  quantity: 'quantity',
  skuId: 'skuId',
  createdAt: 'createdAt',
  createdByUserId: 'createdByUserId',
  updatedByUserId: 'updatedByUserId',
  updatedAt: 'updatedAt',
  rechargeItemId: 'rechargeItemId',
  source: 'source',
  katkinChargeId: 'katkinChargeId',
  katkinItemId: 'katkinItemId'
};

exports.Prisma.OrderFulfilmentEditLogScalarFieldEnum = {
  id: 'id',
  insertedAt: 'insertedAt',
  info: 'info',
  orderFulfilmentId: 'orderFulfilmentId',
  byUserId: 'byUserId'
};

exports.Prisma.BoxSkuScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  insertedAt: 'insertedAt',
  maxWeight: 'maxWeight',
  weight: 'weight',
  oaklandSku: 'oaklandSku'
};

exports.Prisma.NonOaklandFulfilledCustomerScalarFieldEnum = {
  shopifyCustomerId: 'shopifyCustomerId'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  refrigerationRequired: 'refrigerationRequired',
  category: 'category',
  allergens: 'allergens',
  deprecated: 'deprecated',
  subscriptionItemType: 'subscriptionItemType'
};

exports.Prisma.SkuScalarFieldEnum = {
  id: 'id',
  shopifyVariantIds: 'shopifyVariantIds',
  oaklandSku: 'oaklandSku',
  weight: 'weight',
  name: 'name',
  size: 'size',
  productId: 'productId',
  subscriptionItemVariantValue: 'subscriptionItemVariantValue'
};

exports.Prisma.BoxRuleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  types: 'types',
  categories: 'categories',
  pouchSizes: 'pouchSizes',
  minPouchCount: 'minPouchCount',
  maxPouchCount: 'maxPouchCount',
  minBoxNumber: 'minBoxNumber',
  maxBoxNumber: 'maxBoxNumber',
  applyToAllBoxIndexes: 'applyToAllBoxIndexes',
  requiredSkuId: 'requiredSkuId',
  excludedSkuId: 'excludedSkuId',
  starts: 'starts',
  ends: 'ends',
  catLifeStage: 'catLifeStage',
  maxApplicationsPerSubscription: 'maxApplicationsPerSubscription'
};

exports.Prisma.BoxRuleItemScalarFieldEnum = {
  id: 'id',
  ruleId: 'ruleId',
  skuId: 'skuId',
  quantity: 'quantity'
};

exports.Prisma.LockScalarFieldEnum = {
  id: 'id',
  lockedUntil: 'lockedUntil'
};

exports.Prisma.GdprDeletionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  deleterId: 'deleterId',
  created: 'created',
  scheduled: 'scheduled',
  deleted: 'deleted'
};

exports.Prisma.GlobalStatisticsScalarFieldEnum = {
  id: 'id',
  a: 'a',
  b: 'b',
  c: 'c',
  d: 'd',
  e: 'e',
  f: 'f',
  totalCatParents: 'totalCatParents',
  calculated: 'calculated',
  wholeTableScan: 'wholeTableScan'
};

exports.Prisma.DiscountCategoryScalarFieldEnum = {
  name: 'name',
  createdById: 'createdById',
  createdAt: 'createdAt'
};

exports.Prisma.DiscountSubcategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  categoryId: 'categoryId',
  description: 'description',
  createdById: 'createdById',
  createdAt: 'createdAt'
};

exports.Prisma.DiscountGroupScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  createdById: 'createdById',
  createdAt: 'createdAt'
};

exports.Prisma.DiscountCodeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  type: 'type',
  amount: 'amount',
  maxCustomersApplicable: 'maxCustomersApplicable',
  maxChargesPerCustomer: 'maxChargesPerCustomer',
  starts: 'starts',
  ends: 'ends',
  canBeAppliedUntil: 'canBeAppliedUntil',
  applicationDuration: 'applicationDuration',
  canBeAppliedBy: 'canBeAppliedBy',
  applicableProducts: 'applicableProducts',
  applicableChargeTypes: 'applicableChargeTypes',
  note: 'note',
  subcategoryId: 'subcategoryId',
  groupId: 'groupId',
  creditReason: 'creditReason',
  utmMedium: 'utmMedium',
  utmSource: 'utmSource',
  utmCampaign: 'utmCampaign',
  utmContent: 'utmContent',
  utmTerm: 'utmTerm',
  createdAt: 'createdAt',
  createdById: 'createdById',
  lastUpdatedById: 'lastUpdatedById',
  chargeAffectingEditLastMadeAt: 'chargeAffectingEditLastMadeAt',
  lastUsed: 'lastUsed',
  disabledAt: 'disabledAt',
  disabledById: 'disabledById',
  specialCondition: 'specialCondition'
};

exports.Prisma.DiscountAuditLogScalarFieldEnum = {
  id: 'id',
  discountId: 'discountId',
  userId: 'userId',
  timestamp: 'timestamp',
  info: 'info'
};

exports.Prisma.DiscountApplicationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  discountId: 'discountId',
  expiresAt: 'expiresAt',
  appliedAt: 'appliedAt',
  appliedByUserId: 'appliedByUserId',
  chargeCount: 'chargeCount',
  fullyUsedUp: 'fullyUsedUp',
  disabledAt: 'disabledAt',
  disabledById: 'disabledById',
  syncedAt: 'syncedAt',
  syncedFor: 'syncedFor'
};

exports.Prisma.DiscountApplicationToDiscountChargeScalarFieldEnum = {
  discountApplicationId: 'discountApplicationId',
  discountChargeId: 'discountChargeId',
  order: 'order',
  discountAmount: 'discountAmount'
};

exports.Prisma.DiscountChargeScalarFieldEnum = {
  id: 'id',
  chargeId: 'chargeId',
  createdAt: 'createdAt',
  associatedAt: 'associatedAt',
  rechargeDiscountCode: 'rechargeDiscountCode',
  rechargeDiscountId: 'rechargeDiscountId',
  rechargeDiscountAmount: 'rechargeDiscountAmount'
};

exports.Prisma.DiscountedLineItemChargeScalarFieldEnum = {
  discountChargeId: 'discountChargeId',
  purchaseItemId: 'purchaseItemId',
  originalUnitPrice: 'originalUnitPrice',
  quantity: 'quantity',
  originalTotalPrice: 'originalTotalPrice',
  finalUnitPrice: 'finalUnitPrice',
  finalTotalPrice: 'finalTotalPrice',
  unitPriceReducedByAmount: 'unitPriceReducedByAmount',
  totalPriceReducedByAmount: 'totalPriceReducedByAmount'
};

exports.Prisma.DiscountedLineItemApplicationScalarFieldEnum = {
  discountChargeId: 'discountChargeId',
  purchaseItemId: 'purchaseItemId',
  discountApplicationId: 'discountApplicationId',
  originalUnitPrice: 'originalUnitPrice',
  quantity: 'quantity',
  originalTotalPrice: 'originalTotalPrice',
  finalUnitPrice: 'finalUnitPrice',
  finalTotalPrice: 'finalTotalPrice',
  unitPriceReducedByAmount: 'unitPriceReducedByAmount',
  totalPriceReducedByAmount: 'totalPriceReducedByAmount'
};

exports.Prisma.UserStatisticsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  rechargeCustomerId: 'rechargeCustomerId',
  a: 'a',
  b: 'b',
  c: 'c',
  d: 'd',
  e: 'e',
  f: 'f',
  calculated: 'calculated'
};

exports.Prisma.RechargeChargeToCreditChargeScalarFieldEnum = {
  id: 'id',
  rechargeId: 'rechargeId'
};

exports.Prisma.CreditChargeScalarFieldEnum = {
  id: 'id',
  chargeId: 'chargeId',
  amount: 'amount',
  creditApplicationId: 'creditApplicationId'
};

exports.Prisma.CreditApplicationScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  fullyUsedUp: 'fullyUsedUp',
  category: 'category',
  subcategory: 'subcategory',
  userId: 'userId',
  appliedByUserId: 'appliedByUserId',
  appliedAt: 'appliedAt',
  disabledAt: 'disabledAt',
  disabledById: 'disabledById',
  note: 'note'
};

exports.Prisma.DisallowedDeliveryDateScalarFieldEnum = {
  id: 'id',
  deliveryDate: 'deliveryDate',
  createdAt: 'createdAt',
  createdById: 'createdById',
  orderType: 'orderType',
  productType: 'productType',
  reason: 'reason'
};

exports.Prisma.BreederScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  gccfPrefix: 'gccfPrefix',
  xeroContactId: 'xeroContactId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CheckoutBasketScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  body: 'body',
  response: 'response',
  updatedAt: 'updatedAt',
  status: 'status'
};

exports.Prisma.RechargeOrderScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  customerEmail: 'customerEmail',
  rechargeChargeId: 'rechargeChargeId',
  rechargeCustomerId: 'rechargeCustomerId',
  billingAddress: 'billingAddress',
  billingPostcode: 'billingPostcode',
  shippingAddress: 'shippingAddress',
  shippingPostcode: 'shippingPostcode',
  insertedAt: 'insertedAt',
  processedAt: 'processedAt',
  scheduledAt: 'scheduledAt',
  totalPrice: 'totalPrice',
  totalTax: 'totalTax',
  stripeTransactionId: 'stripeTransactionId',
  raw: 'raw',
  deliveryDate: 'deliveryDate'
};

exports.Prisma.RechargeLineItemScalarFieldEnum = {
  purchaseItemId: 'purchaseItemId',
  rechargeOrderId: 'rechargeOrderId',
  productTitle: 'productTitle',
  shopifyProductId: 'shopifyProductId',
  variantTitle: 'variantTitle',
  variantId: 'variantId',
  quantity: 'quantity',
  unitPrice: 'unitPrice',
  catName: 'catName',
  catId: 'catId',
  parentSubscriptionId: 'parentSubscriptionId',
  katkinLegacyCustomerId: 'katkinLegacyCustomerId',
  insertedAt: 'insertedAt',
  raw: 'raw',
  scoopPlanType: 'scoopPlanType',
  deliveryDateOverride: 'deliveryDateOverride',
  katkinSubscriptionId: 'katkinSubscriptionId',
  katkinSubscriptionItemId: 'katkinSubscriptionItemId'
};

exports.Prisma.SurveyResponseScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  surveyId: 'surveyId',
  catId: 'catId',
  fieldName: 'fieldName',
  question: 'question',
  response: 'response',
  createdAt: 'createdAt'
};

exports.Prisma.ExperimentScalarFieldEnum = {
  id: 'id',
  code: 'code',
  name: 'name',
  description: 'description',
  active: 'active',
  startDate: 'startDate',
  endDate: 'endDate',
  maxNumberOfBoxes: 'maxNumberOfBoxes'
};

exports.Prisma.ExperimentToUserScalarFieldEnum = {
  userId: 'userId',
  experimentId: 'experimentId',
  group: 'group',
  active: 'active',
  insertedAt: 'insertedAt',
  expiredAt: 'expiredAt',
  expiredReason: 'expiredReason'
};

exports.Prisma.ShreddedAbTestAssignmentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  isTestVariant: 'isTestVariant',
  createdAt: 'createdAt'
};

exports.Prisma.AbTestAssignmentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  variantName: 'variantName',
  variantValue: 'variantValue',
  createdAt: 'createdAt'
};

exports.Prisma.ShippingAddressScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  province: 'province',
  countryCode: 'countryCode',
  company: 'company',
  phone: 'phone',
  postcode: 'postcode',
  deliveryInstructions: 'deliveryInstructions',
  what3Words: 'what3Words',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  syncedAt: 'syncedAt',
  syncedFor: 'syncedFor',
  rechargeAddressId: 'rechargeAddressId'
};

exports.Prisma.CustomerEventLogScalarFieldEnum = {
  id: 'id',
  targetUserId: 'targetUserId',
  oldData: 'oldData',
  newData: 'newData',
  type: 'type',
  source: 'source',
  causeUserId: 'causeUserId',
  metadata: 'metadata',
  createdAt: 'createdAt',
  targetDataId: 'targetDataId',
  targetCatId: 'targetCatId',
  targetSubscriptionId: 'targetSubscriptionId'
};

exports.Prisma.ExperimentEventLogScalarFieldEnum = {
  id: 'id',
  experimentId: 'experimentId',
  newData: 'newData',
  oldData: 'oldData',
  metadata: 'metadata',
  type: 'type',
  insertedTimestamp: 'insertedTimestamp'
};

exports.Prisma.BillingAddressScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  province: 'province',
  countryCode: 'countryCode',
  company: 'company',
  phone: 'phone',
  postcode: 'postcode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentMethodScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  externalPaymentMethodId: 'externalPaymentMethodId',
  billingAddressId: 'billingAddressId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  syncedAt: 'syncedAt',
  rechargePaymentMethodId: 'rechargePaymentMethodId',
  syncedFor: 'syncedFor'
};

exports.Prisma.SkuToExperimentScalarFieldEnum = {
  skuId: 'skuId',
  experimentId: 'experimentId'
};

exports.Prisma.CatScalarFieldEnum = {
  id: 'id',
  legacyCatId: 'legacyCatId',
  userId: 'userId',
  name: 'name',
  gender: 'gender',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  cxNotes: 'cxNotes',
  suppressionReason: 'suppressionReason',
  suppressedAt: 'suppressedAt'
};

exports.Prisma.CatDetailsScalarFieldEnum = {
  id: 'id',
  breed: 'breed',
  birthday: 'birthday',
  isBirthdayPrecise: 'isBirthdayPrecise',
  bodyType: 'bodyType',
  activityLevel: 'activityLevel',
  isNeutered: 'isNeutered',
  weight: 'weight',
  allergies: 'allergies',
  medicalConditions: 'medicalConditions',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CatSUFAnswersScalarFieldEnum = {
  id: 'id',
  ageAtSignup: 'ageAtSignup',
  foodTypeBeforeKatkin: 'foodTypeBeforeKatkin',
  brandBeforeKatkin: 'brandBeforeKatkin',
  fussiness: 'fussiness',
  benefits: 'benefits',
  primarySwitchReason: 'primarySwitchReason',
  secondarySwitchReasons: 'secondarySwitchReasons',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CatToBreederScalarFieldEnum = {
  id: 'id',
  gccfNumber: 'gccfNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  breederUserId: 'breederUserId'
};

exports.Prisma.SubscriptionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  catId: 'catId',
  subscriptionType: 'subscriptionType',
  subscriptionVariantValue: 'subscriptionVariantValue',
  pricingPlan: 'pricingPlan',
  postChargePricingPlanUpdate: 'postChargePricingPlanUpdate',
  orderCount: 'orderCount',
  shippingAddressId: 'shippingAddressId',
  paymentMethodId: 'paymentMethodId',
  nextDeliveryDate: 'nextDeliveryDate',
  bhMigrationDayDiff: 'bhMigrationDayDiff',
  frequency: 'frequency',
  postChargeFrequencyUpdate: 'postChargeFrequencyUpdate',
  status: 'status',
  statusPrimaryReason: 'statusPrimaryReason',
  statusSecondaryReason: 'statusSecondaryReason',
  statusReasonFreetext: 'statusReasonFreetext',
  statusUpdatedAt: 'statusUpdatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rechargeSubscriptionId: 'rechargeSubscriptionId',
  syncedAt: 'syncedAt',
  syncedFor: 'syncedFor',
  rechargeDeliveryFeeSubscriptionId: 'rechargeDeliveryFeeSubscriptionId',
  deferFirstCharge: 'deferFirstCharge'
};

exports.Prisma.SubscriptionVariantPriceScalarFieldEnum = {
  subscriptionType: 'subscriptionType',
  subscriptionVariantValue: 'subscriptionVariantValue',
  pricingPlan: 'pricingPlan',
  price: 'price'
};

exports.Prisma.SubscriptionVariantScalarFieldEnum = {
  subscriptionType: 'subscriptionType',
  subscriptionVariantValue: 'subscriptionVariantValue',
  shopifyVariantIdPrd: 'shopifyVariantIdPrd',
  shopifyVariantIdStg: 'shopifyVariantIdStg',
  shopifyVariantIdFtr: 'shopifyVariantIdFtr'
};

exports.Prisma.CatSharingSubscriptionScalarFieldEnum = {
  catId: 'catId',
  userId: 'userId',
  subscriptionId: 'subscriptionId',
  createdAt: 'createdAt'
};

exports.Prisma.SubscriptionItemScalarFieldEnum = {
  id: 'id',
  parentSubscriptionId: 'parentSubscriptionId',
  pricingPlan: 'pricingPlan',
  subscriptionItemType: 'subscriptionItemType',
  subscriptionItemVariantValue: 'subscriptionItemVariantValue',
  quantity: 'quantity',
  postChargeQuantityUpdate: 'postChargeQuantityUpdate',
  orderCount: 'orderCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rechargeSubscriptionId: 'rechargeSubscriptionId'
};

exports.Prisma.SubscriptionItemVariantScalarFieldEnum = {
  subscriptionItemType: 'subscriptionItemType',
  subscriptionItemVariantValue: 'subscriptionItemVariantValue',
  shopifyVariantIdPrd: 'shopifyVariantIdPrd',
  shopifyVariantIdStg: 'shopifyVariantIdStg',
  shopifyVariantIdFtr: 'shopifyVariantIdFtr'
};

exports.Prisma.SubscriptionItemVariantPriceScalarFieldEnum = {
  subscriptionItemType: 'subscriptionItemType',
  subscriptionItemVariantValue: 'subscriptionItemVariantValue',
  pricingPlan: 'pricingPlan',
  quantity: 'quantity',
  price: 'price'
};

exports.Prisma.AIGatewayEventLogScalarFieldEnum = {
  id: 'id',
  intercomConversationId: 'intercomConversationId',
  type: 'type',
  createdAt: 'createdAt',
  userId: 'userId',
  status: 'status',
  metadata: 'metadata'
};

exports.Prisma.UserSubscriptionTypeCourierScalarFieldEnum = {
  userId: 'userId',
  courier: 'courier',
  subscriptionType: 'subscriptionType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BoxRuleOrderFulfilmentScalarFieldEnum = {
  orderFulfilmentId: 'orderFulfilmentId',
  boxRuleId: 'boxRuleId',
  subscriptionId: 'subscriptionId',
  userId: 'userId'
};

exports.Prisma.ChargeScalarFieldEnum = {
  chargeId: 'chargeId',
  userId: 'userId',
  status: 'status',
  type: 'type',
  deliveryDate: 'deliveryDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  checkedAt: 'checkedAt',
  scheduledFor: 'scheduledFor',
  finalisedAt: 'finalisedAt',
  notificationSentAt: 'notificationSentAt',
  chargeStartedAt: 'chargeStartedAt',
  discountsPostProcessedAt: 'discountsPostProcessedAt',
  subscriptionsPostProcessedAt: 'subscriptionsPostProcessedAt',
  paymentProcessorTransactionId: 'paymentProcessorTransactionId',
  paymentProcessorResponse: 'paymentProcessorResponse',
  paymentProcessorChargeId: 'paymentProcessorChargeId',
  totalPriceOriginal: 'totalPriceOriginal',
  totalPriceDiscounted: 'totalPriceDiscounted',
  totalDiscountAmount: 'totalDiscountAmount',
  taxAmountOriginal: 'taxAmountOriginal',
  taxAmountDiscounted: 'taxAmountDiscounted',
  deliveryFeeOriginal: 'deliveryFeeOriginal',
  deliveryFeeDiscounted: 'deliveryFeeDiscounted',
  refundAmount: 'refundAmount',
  rechargeChargeId: 'rechargeChargeId',
  rechargeOrderId: 'rechargeOrderId',
  basketId: 'basketId',
  paymentProcessorType: 'paymentProcessorType'
};

exports.Prisma.ChargeShippingAddressScalarFieldEnum = {
  chargeId: 'chargeId',
  shippingAddressId: 'shippingAddressId',
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  province: 'province',
  countryCode: 'countryCode',
  company: 'company',
  phone: 'phone',
  postcode: 'postcode',
  deliveryInstructions: 'deliveryInstructions',
  what3Words: 'what3Words',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rechargeAddressId: 'rechargeAddressId'
};

exports.Prisma.ChargeBillingAddressScalarFieldEnum = {
  chargeId: 'chargeId',
  billingAddressId: 'billingAddressId',
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  province: 'province',
  countryCode: 'countryCode',
  company: 'company',
  phone: 'phone',
  postcode: 'postcode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChargePaymentMethodScalarFieldEnum = {
  chargeId: 'chargeId',
  paymentMethodId: 'paymentMethodId',
  externalPaymentMethodId: 'externalPaymentMethodId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rechargePaymentMethodId: 'rechargePaymentMethodId'
};

exports.Prisma.ChargeSubscriptionScalarFieldEnum = {
  chargeId: 'chargeId',
  subscriptionId: 'subscriptionId',
  catId: 'catId',
  subscriptionType: 'subscriptionType',
  subscriptionVariantValue: 'subscriptionVariantValue',
  pricingPlan: 'pricingPlan',
  postChargePricingPlanUpdate: 'postChargePricingPlanUpdate',
  orderCount: 'orderCount',
  shippingAddressId: 'shippingAddressId',
  paymentMethodId: 'paymentMethodId',
  nextDeliveryDate: 'nextDeliveryDate',
  bhMigrationDayDiff: 'bhMigrationDayDiff',
  frequency: 'frequency',
  postChargeFrequencyUpdate: 'postChargeFrequencyUpdate',
  status: 'status',
  statusPrimaryReason: 'statusPrimaryReason',
  statusSecondaryReason: 'statusSecondaryReason',
  statusReasonFreetext: 'statusReasonFreetext',
  statusUpdatedAt: 'statusUpdatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rechargeSubscriptionId: 'rechargeSubscriptionId',
  rechargeDeliveryFeeSubscriptionId: 'rechargeDeliveryFeeSubscriptionId',
  originalPrice: 'originalPrice',
  discountedPrice: 'discountedPrice',
  priceReducedByAmount: 'priceReducedByAmount',
  deferFirstCharge: 'deferFirstCharge'
};

exports.Prisma.ChargeCatSharingSubscriptionScalarFieldEnum = {
  chargeId: 'chargeId',
  catId: 'catId',
  subscriptionId: 'subscriptionId',
  createdAt: 'createdAt'
};

exports.Prisma.ChargeSubscriptionItemScalarFieldEnum = {
  chargeId: 'chargeId',
  parentSubscriptionId: 'parentSubscriptionId',
  subscriptionItemId: 'subscriptionItemId',
  pricingPlan: 'pricingPlan',
  subscriptionItemType: 'subscriptionItemType',
  subscriptionItemVariantValue: 'subscriptionItemVariantValue',
  quantity: 'quantity',
  postChargeQuantityUpdate: 'postChargeQuantityUpdate',
  orderCount: 'orderCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rechargeSubscriptionId: 'rechargeSubscriptionId',
  originalUnitPrice: 'originalUnitPrice',
  originalTotalPrice: 'originalTotalPrice',
  discountedUnitPrice: 'discountedUnitPrice',
  discountedTotalPrice: 'discountedTotalPrice',
  unitPriceReducedByAmount: 'unitPriceReducedByAmount',
  totalPriceReducedByAmount: 'totalPriceReducedByAmount'
};

exports.Prisma.ChargeDiscountScalarFieldEnum = {
  chargeId: 'chargeId',
  discountApplicationId: 'discountApplicationId',
  originalDeliveryFeePrice: 'originalDeliveryFeePrice',
  discountedDeliveryFeePrice: 'discountedDeliveryFeePrice',
  deliveryFeeDiscountAmount: 'deliveryFeeDiscountAmount',
  discountAmount: 'discountAmount',
  order: 'order'
};

exports.Prisma.ChargeDiscountSubscriptionScalarFieldEnum = {
  chargeId: 'chargeId',
  discountApplicationId: 'discountApplicationId',
  subscriptionId: 'subscriptionId',
  originalPrice: 'originalPrice',
  discountedPrice: 'discountedPrice',
  priceReducedByAmount: 'priceReducedByAmount'
};

exports.Prisma.ChargeDiscountSubscriptionItemScalarFieldEnum = {
  chargeId: 'chargeId',
  discountApplicationId: 'discountApplicationId',
  subscriptionItemId: 'subscriptionItemId',
  originalUnitPrice: 'originalUnitPrice',
  originalTotalPrice: 'originalTotalPrice',
  discountedUnitPrice: 'discountedUnitPrice',
  discountedTotalPrice: 'discountedTotalPrice',
  unitPriceReducedByAmount: 'unitPriceReducedByAmount',
  totalPriceReducedByAmount: 'totalPriceReducedByAmount'
};

exports.Prisma.ChargeRefundScalarFieldEnum = {
  refundId: 'refundId',
  chargeId: 'chargeId',
  refundStatus: 'refundStatus',
  refundAmount: 'refundAmount',
  refundReason: 'refundReason',
  refundReasonDetails: 'refundReasonDetails',
  paymentProcessorRefundId: 'paymentProcessorRefundId',
  paymentProcessorResponse: 'paymentProcessorResponse',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SubscriptionDeliveryDateMigrationRequestTargetScalarFieldEnum = {
  id: 'id',
  date: 'date',
  ratio: 'ratio',
  subscriptionDeliveryDateMigrationRequestId: 'subscriptionDeliveryDateMigrationRequestId'
};

exports.Prisma.SubscriptionDeliveryDateMigrationRequestScalarFieldEnum = {
  id: 'id',
  source: 'source',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PostCheckoutSurveyResponseScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  fieldName: 'fieldName',
  question: 'question',
  response: 'response',
  createdAt: 'createdAt'
};

exports.Prisma.SufQuizAnswerScalarFieldEnum = {
  userId: 'userId',
  formName: 'formName',
  version: 'version',
  quizData: 'quizData',
  errorData: 'errorData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BoxRuleSubscriptionRequirementScalarFieldEnum = {
  id: 'id',
  boxRuleId: 'boxRuleId',
  subscriptionType: 'subscriptionType',
  status: 'status'
};

exports.Prisma.YodelFreshPostcodeScalarFieldEnum = {
  id: 'id',
  postcode: 'postcode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MetaCustomerEventEmissionScalarFieldEnum = {
  id: 'id',
  eventType: 'eventType',
  userId: 'userId',
  qualifyingOrderFulfilmentId: 'qualifyingOrderFulfilmentId',
  sentAt: 'sentAt',
  createdAt: 'createdAt'
};

exports.Prisma.GoogleAdsCustomerEventEmissionScalarFieldEnum = {
  id: 'id',
  eventType: 'eventType',
  userId: 'userId',
  qualifyingOrderFulfilmentId: 'qualifyingOrderFulfilmentId',
  matchType: 'matchType',
  sentAt: 'sentAt',
  createdAt: 'createdAt'
};

exports.Prisma.FreeTreatGiftScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  subscriptionId: 'subscriptionId',
  catId: 'catId',
  product: 'product',
  catName: 'catName',
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  postcode: 'postcode',
  email: 'email',
  phone: 'phone',
  quantity: 'quantity',
  reason: 'reason',
  comments: 'comments',
  createdAt: 'createdAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.RoleOrderByRelevanceFieldEnum = {
  description: 'description'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  oldId: 'oldId',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  fullName: 'fullName',
  fullNameReverse: 'fullNameReverse',
  stripeId: 'stripeId',
  rechargeHash: 'rechargeHash',
  phoneNumber: 'phoneNumber',
  klaviyoProfileId: 'klaviyoProfileId',
  cxNote: 'cxNote'
};

exports.Prisma.UserToRoleOrderByRelevanceFieldEnum = {
  userId: 'userId',
  insertedUserId: 'insertedUserId',
  updatedUserId: 'updatedUserId'
};

exports.Prisma.UserPasswordOrderByRelevanceFieldEnum = {
  userId: 'userId',
  hash: 'hash',
  salt: 'salt'
};

exports.Prisma.PasswordResetLinkOrderByRelevanceFieldEnum = {
  userId: 'userId',
  hash: 'hash'
};

exports.Prisma.AuthLoginCodeOrderByRelevanceFieldEnum = {
  id: 'id',
  passcode: 'passcode',
  redirectTo: 'redirectTo',
  userId: 'userId'
};

exports.Prisma.RefreshTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  token: 'token',
  userId: 'userId'
};

exports.Prisma.OrderFulfilmentOrderByRelevanceFieldEnum = {
  userId: 'userId',
  catName: 'catName',
  legacyCatId: 'legacyCatId',
  createdByUserId: 'createdByUserId',
  updatedByUserId: 'updatedByUserId',
  email: 'email',
  shippingFirstName: 'shippingFirstName',
  shippingLastName: 'shippingLastName',
  shippingAddress1: 'shippingAddress1',
  shippingAddress2: 'shippingAddress2',
  shippingCompany: 'shippingCompany',
  shippingCity: 'shippingCity',
  shippingProvince: 'shippingProvince',
  shippingPostcode: 'shippingPostcode',
  shippingCountry: 'shippingCountry',
  shippingPhone: 'shippingPhone',
  shippingLabel: 'shippingLabel',
  replacementReason: 'replacementReason',
  experimentCode: 'experimentCode',
  yodelConsignment: 'yodelConsignment',
  yodelReference: 'yodelReference',
  yodelLabel: 'yodelLabel'
};

exports.Prisma.OrderFulfilmentItemOrderByRelevanceFieldEnum = {
  createdByUserId: 'createdByUserId',
  updatedByUserId: 'updatedByUserId'
};

exports.Prisma.OrderFulfilmentEditLogOrderByRelevanceFieldEnum = {
  info: 'info',
  byUserId: 'byUserId'
};

exports.Prisma.BoxSkuOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  oaklandSku: 'oaklandSku'
};

exports.Prisma.ProductOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description'
};

exports.Prisma.SkuOrderByRelevanceFieldEnum = {
  oaklandSku: 'oaklandSku',
  name: 'name'
};

exports.Prisma.BoxRuleOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description'
};

exports.Prisma.LockOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.GdprDeletionOrderByRelevanceFieldEnum = {
  userId: 'userId',
  deleterId: 'deleterId'
};

exports.Prisma.DiscountCategoryOrderByRelevanceFieldEnum = {
  name: 'name',
  createdById: 'createdById'
};

exports.Prisma.DiscountSubcategoryOrderByRelevanceFieldEnum = {
  name: 'name',
  categoryId: 'categoryId',
  description: 'description',
  createdById: 'createdById'
};

exports.Prisma.DiscountGroupOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  createdById: 'createdById'
};

exports.Prisma.DiscountCodeOrderByRelevanceFieldEnum = {
  code: 'code',
  note: 'note',
  creditReason: 'creditReason',
  utmMedium: 'utmMedium',
  utmSource: 'utmSource',
  utmCampaign: 'utmCampaign',
  utmContent: 'utmContent',
  utmTerm: 'utmTerm',
  createdById: 'createdById',
  lastUpdatedById: 'lastUpdatedById',
  disabledById: 'disabledById'
};

exports.Prisma.DiscountAuditLogOrderByRelevanceFieldEnum = {
  userId: 'userId',
  info: 'info'
};

exports.Prisma.DiscountApplicationOrderByRelevanceFieldEnum = {
  userId: 'userId',
  appliedByUserId: 'appliedByUserId',
  disabledById: 'disabledById'
};

exports.Prisma.DiscountChargeOrderByRelevanceFieldEnum = {
  rechargeDiscountCode: 'rechargeDiscountCode'
};

exports.Prisma.UserStatisticsOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.CreditApplicationOrderByRelevanceFieldEnum = {
  category: 'category',
  subcategory: 'subcategory',
  userId: 'userId',
  appliedByUserId: 'appliedByUserId',
  disabledById: 'disabledById',
  note: 'note'
};

exports.Prisma.DisallowedDeliveryDateOrderByRelevanceFieldEnum = {
  createdById: 'createdById'
};

exports.Prisma.BreederOrderByRelevanceFieldEnum = {
  userId: 'userId',
  gccfPrefix: 'gccfPrefix',
  xeroContactId: 'xeroContactId'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.CheckoutBasketOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.RechargeOrderOrderByRelevanceFieldEnum = {
  userId: 'userId',
  customerEmail: 'customerEmail',
  billingPostcode: 'billingPostcode',
  shippingPostcode: 'shippingPostcode',
  stripeTransactionId: 'stripeTransactionId'
};

exports.Prisma.RechargeLineItemOrderByRelevanceFieldEnum = {
  productTitle: 'productTitle',
  variantTitle: 'variantTitle',
  catName: 'catName',
  catId: 'catId',
  katkinLegacyCustomerId: 'katkinLegacyCustomerId',
  scoopPlanType: 'scoopPlanType'
};

exports.Prisma.SurveyResponseOrderByRelevanceFieldEnum = {
  userId: 'userId',
  surveyId: 'surveyId',
  catId: 'catId',
  fieldName: 'fieldName',
  question: 'question'
};

exports.Prisma.ExperimentOrderByRelevanceFieldEnum = {
  code: 'code',
  name: 'name',
  description: 'description'
};

exports.Prisma.ExperimentToUserOrderByRelevanceFieldEnum = {
  userId: 'userId',
  group: 'group',
  expiredReason: 'expiredReason'
};

exports.Prisma.ShreddedAbTestAssignmentOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.AbTestAssignmentOrderByRelevanceFieldEnum = {
  userId: 'userId',
  variantName: 'variantName',
  variantValue: 'variantValue'
};

exports.Prisma.ShippingAddressOrderByRelevanceFieldEnum = {
  userId: 'userId',
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  province: 'province',
  company: 'company',
  phone: 'phone',
  postcode: 'postcode',
  deliveryInstructions: 'deliveryInstructions',
  what3Words: 'what3Words'
};

exports.Prisma.CustomerEventLogOrderByRelevanceFieldEnum = {
  targetUserId: 'targetUserId',
  causeUserId: 'causeUserId',
  targetDataId: 'targetDataId'
};

exports.Prisma.BillingAddressOrderByRelevanceFieldEnum = {
  userId: 'userId',
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  province: 'province',
  countryCode: 'countryCode',
  company: 'company',
  phone: 'phone',
  postcode: 'postcode'
};

exports.Prisma.PaymentMethodOrderByRelevanceFieldEnum = {
  userId: 'userId',
  externalPaymentMethodId: 'externalPaymentMethodId'
};

exports.Prisma.CatOrderByRelevanceFieldEnum = {
  legacyCatId: 'legacyCatId',
  userId: 'userId',
  name: 'name',
  cxNotes: 'cxNotes'
};

exports.Prisma.CatSUFAnswersOrderByRelevanceFieldEnum = {
  benefits: 'benefits',
  primarySwitchReason: 'primarySwitchReason',
  secondarySwitchReasons: 'secondarySwitchReasons'
};

exports.Prisma.CatToBreederOrderByRelevanceFieldEnum = {
  breederUserId: 'breederUserId'
};

exports.Prisma.SubscriptionOrderByRelevanceFieldEnum = {
  userId: 'userId',
  statusReasonFreetext: 'statusReasonFreetext'
};

exports.Prisma.CatSharingSubscriptionOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.AIGatewayEventLogOrderByRelevanceFieldEnum = {
  intercomConversationId: 'intercomConversationId',
  userId: 'userId'
};

exports.Prisma.UserSubscriptionTypeCourierOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.BoxRuleOrderFulfilmentOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.ChargeOrderByRelevanceFieldEnum = {
  userId: 'userId',
  paymentProcessorTransactionId: 'paymentProcessorTransactionId',
  paymentProcessorChargeId: 'paymentProcessorChargeId',
  basketId: 'basketId'
};

exports.Prisma.ChargeShippingAddressOrderByRelevanceFieldEnum = {
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  province: 'province',
  company: 'company',
  phone: 'phone',
  postcode: 'postcode',
  deliveryInstructions: 'deliveryInstructions',
  what3Words: 'what3Words'
};

exports.Prisma.ChargeBillingAddressOrderByRelevanceFieldEnum = {
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  province: 'province',
  countryCode: 'countryCode',
  company: 'company',
  phone: 'phone',
  postcode: 'postcode'
};

exports.Prisma.ChargePaymentMethodOrderByRelevanceFieldEnum = {
  externalPaymentMethodId: 'externalPaymentMethodId'
};

exports.Prisma.ChargeSubscriptionOrderByRelevanceFieldEnum = {
  statusReasonFreetext: 'statusReasonFreetext'
};

exports.Prisma.ChargeRefundOrderByRelevanceFieldEnum = {
  refundReason: 'refundReason',
  refundReasonDetails: 'refundReasonDetails',
  paymentProcessorRefundId: 'paymentProcessorRefundId'
};

exports.Prisma.PostCheckoutSurveyResponseOrderByRelevanceFieldEnum = {
  userId: 'userId',
  fieldName: 'fieldName',
  question: 'question'
};

exports.Prisma.SufQuizAnswerOrderByRelevanceFieldEnum = {
  userId: 'userId',
  formName: 'formName'
};

exports.Prisma.YodelFreshPostcodeOrderByRelevanceFieldEnum = {
  postcode: 'postcode'
};

exports.Prisma.MetaCustomerEventEmissionOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.GoogleAdsCustomerEventEmissionOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.FreeTreatGiftOrderByRelevanceFieldEnum = {
  userId: 'userId',
  product: 'product',
  catName: 'catName',
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  postcode: 'postcode',
  email: 'email',
  phone: 'phone',
  reason: 'reason',
  comments: 'comments'
};
exports.RoleType = exports.$Enums.RoleType = {
  CX_AGENT: 'CX_AGENT',
  CX_LEAD: 'CX_LEAD',
  CUTOFF_AGENT: 'CUTOFF_AGENT',
  DEV_SUPERUSER: 'DEV_SUPERUSER',
  DISCOUNT_MANAGER: 'DISCOUNT_MANAGER',
  DISCOUNT_VIEWER: 'DISCOUNT_VIEWER',
  SECURITY_MANAGER: 'SECURITY_MANAGER',
  CUSTOMER: 'CUSTOMER',
  DELIVERY_DATES_MANAGER: 'DELIVERY_DATES_MANAGER',
  BREEDER: 'BREEDER',
  EXPERIMENT_MANAGER: 'EXPERIMENT_MANAGER'
};

exports.Persona = exports.$Enums.Persona = {
  INGREDIENT_INVESTIGATOR: 'INGREDIENT_INVESTIGATOR',
  VET_GUIDED_CAREGIVER: 'VET_GUIDED_CAREGIVER',
  INDULGENT_OWNER: 'INDULGENT_OWNER',
  VALUE_MAINSTREAMER: 'VALUE_MAINSTREAMER',
  SUBSCRIPTION_SEEKER: 'SUBSCRIPTION_SEEKER',
  CASUAL_CAT_OWNER: 'CASUAL_CAT_OWNER'
};

exports.OrderType = exports.$Enums.OrderType = {
  RECURRING: 'RECURRING',
  STARTER: 'STARTER',
  REPLACEMENT: 'REPLACEMENT',
  CUSTOM: 'CUSTOM',
  ONEOFF: 'ONEOFF',
  ALL: 'ALL'
};

exports.OrderSource = exports.$Enums.OrderSource = {
  PURCHASE: 'PURCHASE',
  REPLACEMENT: 'REPLACEMENT',
  CUSTOM: 'CUSTOM'
};

exports.OrderFulfilmentStatus = exports.$Enums.OrderFulfilmentStatus = {
  DRAFT: 'DRAFT',
  SUBMISSION_FAILED: 'SUBMISSION_FAILED',
  SUBMITTED: 'SUBMITTED',
  CANCELLED: 'CANCELLED'
};

exports.OrderCategory = exports.$Enums.OrderCategory = {
  FRESH_MEAL_PLAN: 'FRESH_MEAL_PLAN',
  LITTER: 'LITTER',
  CUSTOM: 'CUSTOM'
};

exports.SkuSize = exports.$Enums.SkuSize = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F'
};

exports.Courier = exports.$Enums.Courier = {
  DPD: 'DPD',
  YODEL: 'YODEL'
};

exports.OrderItemSource = exports.$Enums.OrderItemSource = {
  ORDER: 'ORDER',
  MANUALLY_ADDED: 'MANUALLY_ADDED',
  BOX_RULE: 'BOX_RULE'
};

exports.ProductTag = exports.$Enums.ProductTag = {
  FRESH_MEAL: 'FRESH_MEAL',
  LITTER: 'LITTER',
  TREATS: 'TREATS',
  PACKAGING: 'PACKAGING',
  MISC: 'MISC'
};

exports.SubscriptionItemType = exports.$Enums.SubscriptionItemType = {
  CLUCK: 'CLUCK',
  GOBBLE: 'GOBBLE',
  QUACK: 'QUACK',
  OINK: 'OINK',
  SPLASH: 'SPLASH',
  BAAA: 'BAAA',
  MOOO: 'MOOO',
  SHREDDED_CLUCK: 'SHREDDED_CLUCK',
  SHREDDED_GOBBLE: 'SHREDDED_GOBBLE',
  SWISH: 'SWISH',
  SMOOTH_PECK: 'SMOOTH_PECK',
  SMOOTH_CLUCK: 'SMOOTH_CLUCK',
  SPRINKLES: 'SPRINKLES',
  NIBBLES_CHICKEN: 'NIBBLES_CHICKEN',
  NIBBLES_SALMON: 'NIBBLES_SALMON',
  NIBBLES_CHICKEN_POUCH: 'NIBBLES_CHICKEN_POUCH',
  NIBBLES_SALMON_POUCH: 'NIBBLES_SALMON_POUCH',
  NIBBLES_TUNA_POUCH: 'NIBBLES_TUNA_POUCH',
  SCOOP_HEALTH: 'SCOOP_HEALTH',
  SCOOP_PLANET: 'SCOOP_PLANET',
  TOTE_BAG: 'TOTE_BAG'
};

exports.Allergen = exports.$Enums.Allergen = {
  CHICKEN: 'CHICKEN',
  TURKEY: 'TURKEY',
  BEEF: 'BEEF',
  PORK: 'PORK',
  LAMB: 'LAMB',
  WHITEFISH: 'WHITEFISH',
  DUCK: 'DUCK',
  SALMON: 'SALMON',
  TUNA: 'TUNA'
};

exports.SubscriptionItemVariantValue = exports.$Enums.SubscriptionItemVariantValue = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  DEFAULT: 'DEFAULT'
};

exports.CatLifeStage = exports.$Enums.CatLifeStage = {
  KITTEN: 'KITTEN',
  ADULT: 'ADULT',
  SENIOR: 'SENIOR'
};

exports.DiscountCodeType = exports.$Enums.DiscountCodeType = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  ABSOLUTE_TOTAL: 'ABSOLUTE_TOTAL'
};

exports.DiscountSpecialCondition = exports.$Enums.DiscountSpecialCondition = {
  MULTIPLE_ACTIVE_FRESH_SUBSCRIPTIONS: 'MULTIPLE_ACTIVE_FRESH_SUBSCRIPTIONS',
  FIRST_BOX_SPRINKLES: 'FIRST_BOX_SPRINKLES',
  FIRST_BOX_NIBBLES: 'FIRST_BOX_NIBBLES',
  CREDIT: 'CREDIT',
  ONETIME: 'ONETIME',
  NIBBLES_POUCH_BULK_DISCOUNT: 'NIBBLES_POUCH_BULK_DISCOUNT',
  NIBBLES_POUCH_SUF_DISCOUNT_1: 'NIBBLES_POUCH_SUF_DISCOUNT_1',
  NIBBLES_POUCH_SUF_DISCOUNT_2: 'NIBBLES_POUCH_SUF_DISCOUNT_2'
};

exports.DiscountApplyerType = exports.$Enums.DiscountApplyerType = {
  CUSTOMER: 'CUSTOMER',
  CX: 'CX',
  SYSTEM: 'SYSTEM'
};

exports.DiscountApplicableProduct = exports.$Enums.DiscountApplicableProduct = {
  FRESH_MEAL_PLAN: 'FRESH_MEAL_PLAN',
  HEALTH_SCOOP: 'HEALTH_SCOOP',
  PLANET_SCOOP: 'PLANET_SCOOP',
  CHICKEN_NIBBLES: 'CHICKEN_NIBBLES',
  SALMON_NIBBLES: 'SALMON_NIBBLES',
  CHICKEN_NIBBLES_POUCH: 'CHICKEN_NIBBLES_POUCH',
  SALMON_NIBBLES_POUCH: 'SALMON_NIBBLES_POUCH',
  TUNA_NIBBLES_POUCH: 'TUNA_NIBBLES_POUCH',
  CHICKEN_SPRINKLES: 'CHICKEN_SPRINKLES',
  DELIVERY_FEE: 'DELIVERY_FEE'
};

exports.DiscountApplicableChargeType = exports.$Enums.DiscountApplicableChargeType = {
  CHECKOUT: 'CHECKOUT',
  CROSS_SELL: 'CROSS_SELL',
  RECURRING: 'RECURRING'
};

exports.DeliveryDateOrderType = exports.$Enums.DeliveryDateOrderType = {
  RECURRING: 'RECURRING',
  STARTER: 'STARTER',
  ALL: 'ALL'
};

exports.DeliveryDateProductType = exports.$Enums.DeliveryDateProductType = {
  FRESH: 'FRESH',
  HEALTH_SCOOP: 'HEALTH_SCOOP',
  PLANET_SCOOP: 'PLANET_SCOOP',
  ALL: 'ALL'
};

exports.ReasonDeliveryDateDisallowed = exports.$Enums.ReasonDeliveryDateDisallowed = {
  BANK_HOLIDAY: 'BANK_HOLIDAY',
  CUT_OFF: 'CUT_OFF',
  DELIVERY_COMPANY_CAPACITY: 'DELIVERY_COMPANY_CAPACITY',
  SPREADING_DELIVERIES: 'SPREADING_DELIVERIES',
  OTHER: 'OTHER'
};

exports.CheckoutStatus = exports.$Enums.CheckoutStatus = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
};

exports.ShippingCountryCode = exports.$Enums.ShippingCountryCode = {
  GB: 'GB'
};

exports.CustomerEventLogType = exports.$Enums.CustomerEventLogType = {
  CREATED_SHIPPING_ADDRESS: 'CREATED_SHIPPING_ADDRESS',
  UPDATED_SHIPPING_ADDRESS: 'UPDATED_SHIPPING_ADDRESS',
  CREATED_PAYMENT_METHOD: 'CREATED_PAYMENT_METHOD',
  UPDATED_PAYMENT_METHOD: 'UPDATED_PAYMENT_METHOD',
  DELETED_PAYMENT_METHOD: 'DELETED_PAYMENT_METHOD',
  CREATED_BILLING_ADDRESS: 'CREATED_BILLING_ADDRESS',
  UPDATED_BILLING_ADDRESS: 'UPDATED_BILLING_ADDRESS',
  DELETED_BILLING_ADDRESS: 'DELETED_BILLING_ADDRESS',
  STARTED_CARD_DETAIL_UPDATE: 'STARTED_CARD_DETAIL_UPDATE',
  CREATED_USER: 'CREATED_USER',
  UPDATED_USER: 'UPDATED_USER',
  CREATED_CAT: 'CREATED_CAT',
  UPDATED_CAT: 'UPDATED_CAT',
  CREATED_CAT_DETAILS: 'CREATED_CAT_DETAILS',
  UPDATED_CAT_DETAILS: 'UPDATED_CAT_DETAILS',
  CREATED_CAT_SUF_ANSWERS: 'CREATED_CAT_SUF_ANSWERS',
  UPDATED_CAT_SUF_ANSWERS: 'UPDATED_CAT_SUF_ANSWERS',
  CREATED_CAT_BREEDER_LINK: 'CREATED_CAT_BREEDER_LINK',
  UPDATED_CAT_BREEDER_LINK: 'UPDATED_CAT_BREEDER_LINK',
  CREATED_SUBSCRIPTION: 'CREATED_SUBSCRIPTION',
  UPDATED_SUBSCRIPTION: 'UPDATED_SUBSCRIPTION',
  CREATED_SUBSCRIPTION_ITEM: 'CREATED_SUBSCRIPTION_ITEM',
  UPDATED_SUBSCRIPTION_ITEM: 'UPDATED_SUBSCRIPTION_ITEM',
  CREATED_CAT_SUBSCRIPTION_LINK: 'CREATED_CAT_SUBSCRIPTION_LINK',
  APPLIED_DISCOUNT: 'APPLIED_DISCOUNT',
  DISABLED_DISCOUNT_APPLICATION: 'DISABLED_DISCOUNT_APPLICATION',
  UPDATED_EXTRAS: 'UPDATED_EXTRAS',
  UPDATED_RECIPES: 'UPDATED_RECIPES',
  SUF_QUESTIONS_ANSWERED: 'SUF_QUESTIONS_ANSWERED',
  APPLIED_CREDIT: 'APPLIED_CREDIT',
  ADDED_ONETIME: 'ADDED_ONETIME',
  UPDATED_DELIVERY_DATE: 'UPDATED_DELIVERY_DATE',
  UPDATED_MEAL_PLAN: 'UPDATED_MEAL_PLAN',
  UPDATED_TRAY_SIZE: 'UPDATED_TRAY_SIZE',
  CANCELLED_SUBSCRIPTION: 'CANCELLED_SUBSCRIPTION',
  REACTIVATED_SUBSCRIPTION: 'REACTIVATED_SUBSCRIPTION',
  SUBMITTED_NPS_SURVEY: 'SUBMITTED_NPS_SURVEY',
  CREATED_CHARGE_REFUND: 'CREATED_CHARGE_REFUND',
  UPDATED_CHARGE_REFUND: 'UPDATED_CHARGE_REFUND',
  CANCELLED_ORDER_FULFILMENT: 'CANCELLED_ORDER_FULFILMENT',
  UPDATED_USER_ROLES: 'UPDATED_USER_ROLES',
  UPDATED_CHARGE: 'UPDATED_CHARGE',
  CREATED_CHARGE: 'CREATED_CHARGE',
  REFUNDED_RECHARGE_ORDER: 'REFUNDED_RECHARGE_ORDER',
  SCHEDULED_FOR_DELETION: 'SCHEDULED_FOR_DELETION',
  UPDATED_SUBSCRIPTION_FREQUENCY: 'UPDATED_SUBSCRIPTION_FREQUENCY',
  UPDATED_SCOOP_QUANTITY: 'UPDATED_SCOOP_QUANTITY',
  LOGGED_IN: 'LOGGED_IN'
};

exports.CustomerEventLogSource = exports.$Enums.CustomerEventLogSource = {
  CUSTOMER: 'CUSTOMER',
  ADMIN: 'ADMIN',
  MIGRATION: 'MIGRATION',
  CHECKOUT: 'CHECKOUT',
  BREEDER: 'BREEDER',
  SMS: 'SMS',
  KLAVIYO: 'KLAVIYO',
  AI_GATEWAY: 'AI_GATEWAY',
  CHARGE_PROCESSOR: 'CHARGE_PROCESSOR',
  SYSTEM: 'SYSTEM'
};

exports.ExperimentEventLogType = exports.$Enums.ExperimentEventLogType = {
  EXPERIMENT_CREATED: 'EXPERIMENT_CREATED',
  EXPERIMENT_UPDATED: 'EXPERIMENT_UPDATED',
  CUSTOMER_ADDED_TO_EXPERIMENT: 'CUSTOMER_ADDED_TO_EXPERIMENT',
  CUSTOMER_EXPERIMENT_EXPIRED: 'CUSTOMER_EXPERIMENT_EXPIRED'
};

exports.CatGender = exports.$Enums.CatGender = {
  BOY: 'BOY',
  GIRL: 'GIRL',
  UNKNOWN: 'UNKNOWN'
};

exports.CatSuppressionReason = exports.$Enums.CatSuppressionReason = {
  PASSED_AWAY: 'PASSED_AWAY',
  REHOMED: 'REHOMED',
  GONE_MISSING: 'GONE_MISSING',
  TERMINALLY_ILL: 'TERMINALLY_ILL',
  OTHER_SUPPRESSION_REASON: 'OTHER_SUPPRESSION_REASON'
};

exports.CatBreed = exports.$Enums.CatBreed = {
  DOMESTIC_SHORT_HAIR: 'DOMESTIC_SHORT_HAIR',
  DOMESTIC_MEDIUM_HAIR: 'DOMESTIC_MEDIUM_HAIR',
  DOMESTIC_LONG_HAIR: 'DOMESTIC_LONG_HAIR',
  BRITISH_SHORTHAIR: 'BRITISH_SHORTHAIR',
  BRITISH_LONGHAIR: 'BRITISH_LONGHAIR',
  ABYSSINIAN: 'ABYSSINIAN',
  AMERICAN_BOBTAIL: 'AMERICAN_BOBTAIL',
  AMERICAN_CURL: 'AMERICAN_CURL',
  AMERICAN_SHORTHAIR: 'AMERICAN_SHORTHAIR',
  BALINESE: 'BALINESE',
  BENGAL: 'BENGAL',
  BIRMAN: 'BIRMAN',
  BURMESE: 'BURMESE',
  BURMILLA: 'BURMILLA',
  CHAUSIE: 'CHAUSIE',
  CHINCHILLA: 'CHINCHILLA',
  CORNISH_REX: 'CORNISH_REX',
  DEVON_REX: 'DEVON_REX',
  EXOTIC_SHORTHAIR: 'EXOTIC_SHORTHAIR',
  JAPANESE_BOBTAIL: 'JAPANESE_BOBTAIL',
  KORAT: 'KORAT',
  KURILIAN_BOBTAILS: 'KURILIAN_BOBTAILS',
  LAPERM: 'LAPERM',
  MAINE_COON: 'MAINE_COON',
  MANX: 'MANX',
  MOGGIE: 'MOGGIE',
  NORWEGIAN_FOREST_CAT: 'NORWEGIAN_FOREST_CAT',
  OCICAT: 'OCICAT',
  ORIENTAL_SHORTHAIR: 'ORIENTAL_SHORTHAIR',
  PERSIAN: 'PERSIAN',
  PETERBALD: 'PETERBALD',
  PIXIE_BOB: 'PIXIE_BOB',
  RAGAMUFFIN: 'RAGAMUFFIN',
  RAGDOLL: 'RAGDOLL',
  RUSSIAN_BLUE: 'RUSSIAN_BLUE',
  SAVANNAH: 'SAVANNAH',
  SCOTTISH_FOLD: 'SCOTTISH_FOLD',
  SIAMESE: 'SIAMESE',
  SIBERIAN_FOREST_CAT: 'SIBERIAN_FOREST_CAT',
  SINGAPURA: 'SINGAPURA',
  SNOWSHOE: 'SNOWSHOE',
  SOMALI: 'SOMALI',
  SPHYNX: 'SPHYNX',
  TIFFANIE: 'TIFFANIE',
  TONKINESE: 'TONKINESE',
  TURKISH_ANGORA: 'TURKISH_ANGORA',
  TURKISH_VAN: 'TURKISH_VAN',
  OTHER: 'OTHER',
  I_DONT_KNOW_THEIR_BREED: 'I_DONT_KNOW_THEIR_BREED',
  UNKNOWN: 'UNKNOWN'
};

exports.CatBodyType = exports.$Enums.CatBodyType = {
  VERY_THIN: 'VERY_THIN',
  THIN: 'THIN',
  JUST_RIGHT: 'JUST_RIGHT',
  OVERWEIGHT: 'OVERWEIGHT',
  VERY_OVERWEIGHT: 'VERY_OVERWEIGHT',
  UNKNOWN: 'UNKNOWN'
};

exports.CatActivityLevel = exports.$Enums.CatActivityLevel = {
  INDOOR_LOW_ACTIVITY: 'INDOOR_LOW_ACTIVITY',
  INDOOR_HIGH_ACTIVITY: 'INDOOR_HIGH_ACTIVITY',
  INDOOR_AND_OUTDOOR: 'INDOOR_AND_OUTDOOR',
  MOSTLY_OUTDOOR: 'MOSTLY_OUTDOOR',
  UNKNOWN: 'UNKNOWN'
};

exports.CatMedicalCondition = exports.$Enums.CatMedicalCondition = {
  A_FOOD_ALLERGY: 'A_FOOD_ALLERGY',
  INFLAMMATORY_BOWEL_DISEASE: 'INFLAMMATORY_BOWEL_DISEASE',
  DIABETES: 'DIABETES',
  KIDNEY_DISEASE: 'KIDNEY_DISEASE',
  URINARY_DISEASE: 'URINARY_DISEASE',
  DIARRHOEA_OF_AN_UNKNOWN_CAUSE: 'DIARRHOEA_OF_AN_UNKNOWN_CAUSE',
  VOMITING_OF_AN_UNKNOWN_CAUSE: 'VOMITING_OF_AN_UNKNOWN_CAUSE',
  HYPERTHYROIDISM: 'HYPERTHYROIDISM',
  PANCREATITIS: 'PANCREATITIS',
  CYSTITIS: 'CYSTITIS',
  ARTHRITIS: 'ARTHRITIS',
  LIVER_DISEASE: 'LIVER_DISEASE',
  FELINE_ASTHMAS: 'FELINE_ASTHMAS',
  EPILEPSY: 'EPILEPSY',
  CANCER: 'CANCER',
  OTHER: 'OTHER'
};

exports.CatBrandBefore = exports.$Enums.CatBrandBefore = {
  FELIX: 'FELIX',
  WHISKAS: 'WHISKAS',
  GOURMET: 'GOURMET',
  SHEBA: 'SHEBA',
  ROYAL_CANIN: 'ROYAL_CANIN',
  PURINA_ONE: 'PURINA_ONE',
  APPLAWS: 'APPLAWS',
  AARDVARK: 'AARDVARK',
  ALMO_NATURE: 'ALMO_NATURE',
  AVA: 'AVA',
  BLINK: 'BLINK',
  BURNS: 'BURNS',
  CARNILOVE: 'CARNILOVE',
  CRAVE: 'CRAVE',
  EDGARD_COOPER: 'EDGARD_COOPER',
  ENCORE: 'ENCORE',
  FERINGA: 'FERINGA',
  FRESHPET: 'FRESHPET',
  GO_CAT: 'GO_CAT',
  HARRINGTONS: 'HARRINGTONS',
  HILLS: 'HILLS',
  IAMS: 'IAMS',
  JAMES_WELLBELOVED: 'JAMES_WELLBELOVED',
  KATKIN: 'KATKIN',
  LILYS_KITCHEN: 'LILYS_KITCHEN',
  MEOWING_HEADS: 'MEOWING_HEADS',
  NATURAL_INSTINCT: 'NATURAL_INSTINCT',
  NATURES_MENU: 'NATURES_MENU',
  NUTRIMENT: 'NUTRIMENT',
  ORIJEN: 'ORIJEN',
  PURR_AND_MIAOW: 'PURR_AND_MIAOW',
  PURRFORM: 'PURRFORM',
  REPUBLIC_OF_CATS: 'REPUBLIC_OF_CATS',
  SCRUMBLES: 'SCRUMBLES',
  SUPERMARKET_BRAND: 'SUPERMARKET_BRAND',
  THRIVE: 'THRIVE',
  TOMOJO: 'TOMOJO',
  UNTAMED: 'UNTAMED',
  MARRO: 'MARRO',
  OTHER: 'OTHER',
  UNKNOWN: 'UNKNOWN'
};

exports.CatFussiness = exports.$Enums.CatFussiness = {
  NOT_FUSSY: 'NOT_FUSSY',
  QUITE_FUSSY: 'QUITE_FUSSY',
  VERY_FUSSY: 'VERY_FUSSY',
  UNKNOWN: 'UNKNOWN'
};

exports.CatFoodTypeBefore = exports.$Enums.CatFoodTypeBefore = {
  DRY: 'DRY',
  WET: 'WET',
  RAW: 'RAW',
  HOME_COOKED: 'HOME_COOKED',
  FRESH: 'FRESH'
};

exports.SubscriptionType = exports.$Enums.SubscriptionType = {
  FRESH: 'FRESH',
  SCOOP_HEALTH: 'SCOOP_HEALTH',
  SCOOP_PLANET: 'SCOOP_PLANET'
};

exports.SubscriptionVariantValue = exports.$Enums.SubscriptionVariantValue = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  DEFAULT: 'DEFAULT'
};

exports.PricingPlan = exports.$Enums.PricingPlan = {
  HALF: 'HALF',
  STANDARD: 'STANDARD',
  FREEZER: 'FREEZER',
  SAVER: 'SAVER',
  TRIAL: 'TRIAL',
  TRIAL_WEEK: 'TRIAL_WEEK'
};

exports.SubscriptionStatus = exports.$Enums.SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED'
};

exports.SubscriptionStatusPrimaryReason = exports.$Enums.SubscriptionStatusPrimaryReason = {
  CX_UNKNOWN: 'CX_UNKNOWN',
  AI_UNKNOWN: 'AI_UNKNOWN',
  TESTING_TEAM: 'TESTING_TEAM',
  LEGACY_UNKNOWN: 'LEGACY_UNKNOWN',
  LEGACY_COVID_19: 'LEGACY_COVID_19',
  LEGACY_CUSTOMER_ERROR: 'LEGACY_CUSTOMER_ERROR',
  INTERNAL_MAX_NUMBER_OF_CHARGE_ATTEMPTS_REACHED: 'INTERNAL_MAX_NUMBER_OF_CHARGE_ATTEMPTS_REACHED',
  COMING_BACK: 'COMING_BACK',
  FOOD_LEFT_OVER: 'FOOD_LEFT_OVER',
  HEALTH_REASONS: 'HEALTH_REASONS',
  LIMITED_FREEZER_SPACE: 'LIMITED_FREEZER_SPACE',
  NEW_PACKAGING: 'NEW_PACKAGING',
  NOT_EATING: 'NOT_EATING',
  PASSED_AWAY: 'PASSED_AWAY',
  REHOMED: 'REHOMED',
  GONE_MISSING: 'GONE_MISSING',
  TERMINALLY_ILL: 'TERMINALLY_ILL',
  PRODUCT_CHANGE_24: 'PRODUCT_CHANGE_24',
  REVOKED_PAYMENT_MANDATE: 'REVOKED_PAYMENT_MANDATE',
  SUB_DOESNT_WORK: 'SUB_DOESNT_WORK',
  TOO_EXPENSIVE: 'TOO_EXPENSIVE',
  TOO_MUCH_KATKIN: 'TOO_MUCH_KATKIN',
  UNHAPPY_WITH_SERVICE: 'UNHAPPY_WITH_SERVICE',
  CAT_WOULDNT_USE: 'CAT_WOULDNT_USE',
  DIDNT_CLUMP_WELL: 'DIDNT_CLUMP_WELL',
  DISLIKE_SMELL: 'DISLIKE_SMELL',
  TOO_SMALL: 'TOO_SMALL',
  OTHER: 'OTHER',
  OTHER_SUPPRESSION_REASON: 'OTHER_SUPPRESSION_REASON',
  GCCF_PAYMENT_DETAILS_NOT_ADDED: 'GCCF_PAYMENT_DETAILS_NOT_ADDED'
};

exports.SubscriptionStatusSecondaryReason = exports.$Enums.SubscriptionStatusSecondaryReason = {
  ACCUMULATION_OVER_TIME: 'ACCUMULATION_OVER_TIME',
  BAD_REACTION: 'BAD_REACTION',
  COMINGBACK_MULTIFEEDING: 'COMINGBACK_MULTIFEEDING',
  DELIVERYCOST: 'DELIVERYCOST',
  DONT_LIKE_MONTHLY_PAYMENTS: 'DONT_LIKE_MONTHLY_PAYMENTS',
  EASIER_TO_BUY_FROM_SHOP: 'EASIER_TO_BUY_FROM_SHOP',
  EXPENSIVE_WORTH: 'EXPENSIVE_WORTH',
  FOOD_DIFFERENT: 'FOOD_DIFFERENT',
  GOING_ON_HOLIDAY: 'GOING_ON_HOLIDAY',
  HARD_TO_RECYCLE: 'HARD_TO_RECYCLE',
  HARD_TO_SERVE: 'HARD_TO_SERVE',
  HAVE_ENOUGH_FOR_NOW: 'HAVE_ENOUGH_FOR_NOW',
  ISSUE_WITH_DELIVERY: 'ISSUE_WITH_DELIVERY',
  LEFTOVER_FOOD: 'LEFTOVER_FOOD',
  LIKED_SOME_RECIPES: 'LIKED_SOME_RECIPES',
  MULTI_FEEDING: 'MULTI_FEEDING',
  NEED_LESS_FOOD_THAN_SUBSCRIPTION: 'NEED_LESS_FOOD_THAN_SUBSCRIPTION',
  NEED_MORE_FOOD_THAN_SUBSCRIPTION: 'NEED_MORE_FOOD_THAN_SUBSCRIPTION',
  NEW_FOOD_24: 'NEW_FOOD_24',
  NO_MORE_ROOM: 'NO_MORE_ROOM',
  NOT_EATING_ENOUGH: 'NOT_EATING_ENOUGH',
  NOT_ENOUGH_FOOD_CLEARLY_HUNGRY: 'NOT_ENOUGH_FOOD_CLEARLY_HUNGRY',
  NOT_ENTHUSIASTIC_ENOUGH: 'NOT_ENTHUSIASTIC_ENOUGH',
  NOT_WHAT_VET_RECOMMENDS: 'NOT_WHAT_VET_RECOMMENDS',
  OTHER_BRANDS_CHEAPER: 'OTHER_BRANDS_CHEAPER',
  OVER_MY_BUDGET: 'OVER_MY_BUDGET',
  PACKAGING_BOX: 'PACKAGING_BOX',
  PACKAGING_POUCHES: 'PACKAGING_POUCHES',
  PACKAGING_TRAYS: 'PACKAGING_TRAYS',
  PREFER_TO_BUY_WHEN_I_NEED_IT: 'PREFER_TO_BUY_WHEN_I_NEED_IT',
  REQUIRE_DIFFERENT_KIND_OF_FOOD: 'REQUIRE_DIFFERENT_KIND_OF_FOOD',
  TOO_EXPENSIVE_FOR_MULTIPLE_CATS: 'TOO_EXPENSIVE_FOR_MULTIPLE_CATS',
  UNHAPPY_DPD: 'UNHAPPY_DPD',
  UNHAPPY_OTHER: 'UNHAPPY_OTHER',
  UNHAPPY_QUALITY: 'UNHAPPY_QUALITY',
  UNHAPPY_SERVICE: 'UNHAPPY_SERVICE',
  UNSATISFACTORY_CUSTOMER_SERVICE: 'UNSATISFACTORY_CUSTOMER_SERVICE',
  UPSET_STOMACH: 'UPSET_STOMACH',
  VOMITING_OR_LOOSE_STOOLS: 'VOMITING_OR_LOOSE_STOOLS',
  WANT_TO_TRY_FIRST_BOX: 'WANT_TO_TRY_FIRST_BOX',
  WENT_OFF_FOOD: 'WENT_OFF_FOOD',
  WONT_EAT_AT_ALL: 'WONT_EAT_AT_ALL',
  LEGACY_UNKNOWN: 'LEGACY_UNKNOWN',
  UNAWARE_OF_SUB: 'UNAWARE_OF_SUB',
  BUYING_AT_RETAIL: 'BUYING_AT_RETAIL'
};

exports.AIGatewayEventLogType = exports.$Enums.AIGatewayEventLogType = {
  UNSUBSCRIBE_REQUEST: 'UNSUBSCRIBE_REQUEST',
  UPDATE_MEAL_PLAN_REQUEST: 'UPDATE_MEAL_PLAN_REQUEST',
  UPDATE_RECIPES_REQUEST: 'UPDATE_RECIPES_REQUEST',
  UPDATE_DELIVERY_DATE_REQUEST: 'UPDATE_DELIVERY_DATE_REQUEST',
  UPDATE_TRAY_SIZE_REQUEST: 'UPDATE_TRAY_SIZE_REQUEST',
  DELETE_SUBSCRIPTION_REQUEST: 'DELETE_SUBSCRIPTION_REQUEST'
};

exports.AIGatewayEventLogStatus = exports.$Enums.AIGatewayEventLogStatus = {
  SUCCESS: 'SUCCESS',
  REJECTED: 'REJECTED',
  ERROR: 'ERROR'
};

exports.ChargeStatus = exports.$Enums.ChargeStatus = {
  QUEUED: 'QUEUED',
  NEEDS_REGENERATION: 'NEEDS_REGENERATION',
  CHARGING: 'CHARGING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
};

exports.PaymentProcessorType = exports.$Enums.PaymentProcessorType = {
  STRIPE_SETUP_INTENT: 'STRIPE_SETUP_INTENT',
  STRIPE_PAYMENT_INTENT: 'STRIPE_PAYMENT_INTENT',
  STRIPE_CHECKOUT_SESSION: 'STRIPE_CHECKOUT_SESSION'
};

exports.RefundStatus = exports.$Enums.RefundStatus = {
  PENDING: 'PENDING',
  REFUNDED: 'REFUNDED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
};

exports.SubscriptionDeliveryDateMigrationRequestStatus = exports.$Enums.SubscriptionDeliveryDateMigrationRequestStatus = {
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.FulfilmentSubscriptionStatus = exports.$Enums.FulfilmentSubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  NEVER: 'NEVER'
};

exports.MetaCustomerEventType = exports.$Enums.MetaCustomerEventType = {
  SUBSCRIBE: 'SUBSCRIBE'
};

exports.GoogleAdsCustomerEventType = exports.$Enums.GoogleAdsCustomerEventType = {
  POST_TRIAL_CONVERSION: 'POST_TRIAL_CONVERSION'
};

exports.GoogleAdsCustomerEventMatchType = exports.$Enums.GoogleAdsCustomerEventMatchType = {
  CLICK: 'CLICK',
  MODELLED: 'MODELLED'
};

exports.Prisma.ModelName = {
  Role: 'Role',
  User: 'User',
  UserToRole: 'UserToRole',
  UserPassword: 'UserPassword',
  PasswordResetLink: 'PasswordResetLink',
  AuthLoginCode: 'AuthLoginCode',
  RefreshToken: 'RefreshToken',
  OrderFulfilment: 'OrderFulfilment',
  OrderFulfilmentItem: 'OrderFulfilmentItem',
  OrderFulfilmentEditLog: 'OrderFulfilmentEditLog',
  BoxSku: 'BoxSku',
  NonOaklandFulfilledCustomer: 'NonOaklandFulfilledCustomer',
  Product: 'Product',
  Sku: 'Sku',
  BoxRule: 'BoxRule',
  BoxRuleItem: 'BoxRuleItem',
  Lock: 'Lock',
  GdprDeletion: 'GdprDeletion',
  GlobalStatistics: 'GlobalStatistics',
  DiscountCategory: 'DiscountCategory',
  DiscountSubcategory: 'DiscountSubcategory',
  DiscountGroup: 'DiscountGroup',
  DiscountCode: 'DiscountCode',
  DiscountAuditLog: 'DiscountAuditLog',
  DiscountApplication: 'DiscountApplication',
  DiscountApplicationToDiscountCharge: 'DiscountApplicationToDiscountCharge',
  DiscountCharge: 'DiscountCharge',
  DiscountedLineItemCharge: 'DiscountedLineItemCharge',
  DiscountedLineItemApplication: 'DiscountedLineItemApplication',
  UserStatistics: 'UserStatistics',
  RechargeChargeToCreditCharge: 'RechargeChargeToCreditCharge',
  CreditCharge: 'CreditCharge',
  CreditApplication: 'CreditApplication',
  DisallowedDeliveryDate: 'DisallowedDeliveryDate',
  Breeder: 'Breeder',
  CheckoutBasket: 'CheckoutBasket',
  RechargeOrder: 'RechargeOrder',
  RechargeLineItem: 'RechargeLineItem',
  SurveyResponse: 'SurveyResponse',
  Experiment: 'Experiment',
  ExperimentToUser: 'ExperimentToUser',
  ShreddedAbTestAssignment: 'ShreddedAbTestAssignment',
  AbTestAssignment: 'AbTestAssignment',
  ShippingAddress: 'ShippingAddress',
  CustomerEventLog: 'CustomerEventLog',
  ExperimentEventLog: 'ExperimentEventLog',
  BillingAddress: 'BillingAddress',
  PaymentMethod: 'PaymentMethod',
  SkuToExperiment: 'SkuToExperiment',
  Cat: 'Cat',
  CatDetails: 'CatDetails',
  CatSUFAnswers: 'CatSUFAnswers',
  CatToBreeder: 'CatToBreeder',
  Subscription: 'Subscription',
  SubscriptionVariantPrice: 'SubscriptionVariantPrice',
  SubscriptionVariant: 'SubscriptionVariant',
  CatSharingSubscription: 'CatSharingSubscription',
  SubscriptionItem: 'SubscriptionItem',
  SubscriptionItemVariant: 'SubscriptionItemVariant',
  SubscriptionItemVariantPrice: 'SubscriptionItemVariantPrice',
  AIGatewayEventLog: 'AIGatewayEventLog',
  UserSubscriptionTypeCourier: 'UserSubscriptionTypeCourier',
  BoxRuleOrderFulfilment: 'BoxRuleOrderFulfilment',
  Charge: 'Charge',
  ChargeShippingAddress: 'ChargeShippingAddress',
  ChargeBillingAddress: 'ChargeBillingAddress',
  ChargePaymentMethod: 'ChargePaymentMethod',
  ChargeSubscription: 'ChargeSubscription',
  ChargeCatSharingSubscription: 'ChargeCatSharingSubscription',
  ChargeSubscriptionItem: 'ChargeSubscriptionItem',
  ChargeDiscount: 'ChargeDiscount',
  ChargeDiscountSubscription: 'ChargeDiscountSubscription',
  ChargeDiscountSubscriptionItem: 'ChargeDiscountSubscriptionItem',
  ChargeRefund: 'ChargeRefund',
  SubscriptionDeliveryDateMigrationRequestTarget: 'SubscriptionDeliveryDateMigrationRequestTarget',
  SubscriptionDeliveryDateMigrationRequest: 'SubscriptionDeliveryDateMigrationRequest',
  PostCheckoutSurveyResponse: 'PostCheckoutSurveyResponse',
  SufQuizAnswer: 'SufQuizAnswer',
  BoxRuleSubscriptionRequirement: 'BoxRuleSubscriptionRequirement',
  YodelFreshPostcode: 'YodelFreshPostcode',
  MetaCustomerEventEmission: 'MetaCustomerEventEmission',
  GoogleAdsCustomerEventEmission: 'GoogleAdsCustomerEventEmission',
  FreeTreatGift: 'FreeTreatGift'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
